// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falDash: CreateIconOptions = {
  "displayName": "FALDash",
  "viewBox": "0, 0, 512, 512",
  "d": "M0 256c0-8.8 7.2-16 16-16l480 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 272c-8.8 0-16-7.2-16-16z"
};
